export enum ModerationRejectKey {
    kazakhLaw = 'kazakh-law',
    copyright = 'copyright',
    spam = 'spam',
    russianLaw = 'russian-law',
    russianLawCallout = 'russian-law-callout',
    yandexPolicy = 'yandex-policy',
    siteRequirements = 'site-requirements',
    newsRequirements = 'news-requirements',
    falseInfo = 'false-info',
    errors = 'errors',
    tm = 'tm',
    invalidUrl = 'invalid-url',
    politics = 'politics',
    contactInfo = 'contact-info',
    licenseRequired = 'license-required',
    irrelevantKeywords = 'irrelevant-keywords',
    russianLawVcard = 'russian-law-vcard',
    licenseRequiredVcard = 'license-required-vcard',
    falseInfoVcard = 'false-info-vcard',
    phoneDoesntAnswer = "phone-doesn't-answer",
    invalidContacts = 'invalid-contacts',
    yandexPolicyAuto = 'yandex-policy-auto',
    yandexPolicyVcard = 'yandex-policy-vcard',
    blacklist = 'blacklist',
    errorsVcard = 'errors-vcard',
    irrelevantImage = 'irrelevant-image',
    yandexPolicyImage = 'yandex-policy-image',
    poorImage = 'poor-image',
    russianLawImage = 'russian-law-image',
    russianLawQl = 'russian-law-ql',
    qlRequirements = 'ql-requirements',
    errorsQl = 'errors-ql',
    invalidUrlQl = 'invalid-url-ql',
    urlToOtherDomain = 'url-to-other-domain',
    licenseRequiredQl = 'license-required-ql',
    irrelevantMobileContent = 'irrelevant-mobile_content',
    irrelevantSiteLinkDescription = 'irrelevant-site_link-description',
    yandexPolicyCallout = 'yandex-policy-callout',
    errorsCallout = 'errors-callout',
    contactInfoCallout = 'contact-info-callout',
    falseInfoCallout = 'false-info-callout',
    dhrefRequirements = 'dhref-requirements',
    licenseRequiredDhref = 'license-required-dhref',
    tmDhref = 'tm-dhref',
    russianLawDhref = 'russian-law-dhref',
    adImageBadText = 'ad_image-bad-text',
    adImageNoBorder = 'ad_image-no-border',
    adImageBadQuality = 'ad_image-bad-quality',
    adImageNoSource = 'ad_image-no-source',
    adImageNasty = 'ad_image-nasty',
    adImageInterfaceElement = 'ad-image-interface-element',
    adImageFinance = 'ad_image-finance',
    adImageLottery = 'ad_image-lottery',
    adImageShareBuilding = 'ad_image-share-building',
    adImageDistance = 'ad_image-distance',
    adImageMedicine = 'ad_image-medicine',
    adImageSmi = 'ad_image-smi',
    adImageBabyfood = 'ad_image-babyfood',
    adImageHouseCooperative = 'ad_image-house-cooperative',
    videoSmi = 'video_smi',
    videoMedicine = 'video_medicine',
    videoHouseCooperative = 'video_house_cooperative',
    videoLottery = 'video_lottery',
    videoShareBuilding = 'video_share_building',
    videoFinance = 'video_finance',
    videoDistanceSales = 'video_distance_sales',
    videoBabyfood = 'video_babyfood',
    videoRequirements = 'video_requirements',
    audioRequirements = 'audio_requirements',
    turbolandingRequirements = 'turbolanding-requirements',
    turbolandingRequirementsSlink = 'turbolanding-requirements-slink',
    html5Nasty = 'html5-nasty',
    html5Babyfood = 'html5-babyfood',
    html5Finance = 'html5-finance',
    html5Funds = 'html5-funds',
    html5BadQuality = 'html5-bad-quality',
    html5RussianLaw = 'html5-russian-law',
    html5Illness = 'html5-illness',
    html5Spam = 'html5-spam',
    html5HouseCooperative = 'html5-house-cooperative',
    html5InterfaceElement = 'html5-interface-element',
    html5NoBorder = 'html5-no-border',
    html5HrefsErrors = 'html5-hrefs-errors',
    html5NoSource = 'html5-no-source',
    html5Smi = 'html5-smi',
    html5Securities = 'html5-securities',
    html5Lottery = 'html5-lottery',
    html5ShareBuilding = 'html5-share-building',
    html5BadText = 'html5-bad-text',
    html5Medicine = 'html5-medicine'
}

export interface ModerationRejectOutdoorReasonsItem {
    pageName: string;
    pageId: string;
    operatorComment?: string;
    externalId: Set<string>;
    reasons: Array<ModerationRejectReason>;
}

export type OutdoorRejectFullReason = {
    key: 'outdoor';
    reasons: Array<ModerationRejectOutdoorReasonsItem>;
};

export type ModerationRejectReason =
    | { key: ModerationRejectKey }
    | { key: 'external'; externalId: Set<string> }
    | { key: 'externalItem'; title: string; text: string }
    | { key: 'other'; recommendations: Array<string> }
    | OutdoorRejectFullReason;

export interface ParseExternalModerationRejectReason {
    content: string;
    selector: Record<string, string>;
}
